import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FilterField = iotsUtils.fromList(constants.wholeHouse.bom.search.filterFields);
